import $ from 'jquery';

const questionnaire = {
    init: function() {
        const checkPage = document.querySelector('.questionnaire-block__form');
        if ( ! checkPage ) {
            return;
        }

        const companySelect = checkPage.querySelector('[data-name="select-company"]');
        if ( companySelect ) {
            this.populateSelect('select-company', questForm.fields.companies);
        }

        const companyOffice = checkPage.querySelector('[data-name="select-office"]');
        if ( companyOffice ) {
            companyOffice.closest('.contact-form__row').style.display = "none";
            this.populateSelect('select-office', questForm.fields.offices);
        }

        this.thankYouModal();
        this.showOfficeInput();
    },

    populateSelect: function(dataName, items) {

        if ( ! items.length ) {
            return;
        }

        const selectWrapper = document.querySelector(`[data-name="${dataName}"]`);
        const selectElement = selectWrapper.querySelector('select');

        items.forEach(function(item) {
            const option = document.createElement('option');
            option.value = item.item;
            option.text = item.item;
            selectElement.appendChild(option);
        });
    },

    thankYouModal() {
		$( '.contact-form__questionnaire' ).each(
			function() {
				let form       = $( this ).parent().parent(),
				content        = '<p>Dziękujemy za wypełnienie formularza</p>',
				modal_thankyou = $( '.thankyou-modal' );

				$( form ).on(
					'wpcf7mailsent',
					function() {

						const closeModalButton = modal_thankyou.find( '.js-close-contact-form-modal' );

                        $(
                            '<div />',
                            {
                                class: 'thankyou-modal__text-wrapper',
                                html: content,
                            }
                        ).appendTo( modal_thankyou.find( '.thankyou-modal__content' ) );

                        modal_thankyou.fadeIn();

						closeModalButton.click(
							function (e) {
								e.preventDefault();
								modal_thankyou.fadeOut();
								setTimeout( function() {modal_thankyou.find( '.thankyou-modal__content .thankyou-modal__text-wrapper' ).remove()},500 )
							}
						)

					}
				)
			}
		)
	},

    showOfficeInput() {
        const companyInput = $('[data-name="select-company"] select');
        const officeInput = $('[data-name="select-office"]');
        const officeInputWrapper = officeInput.closest('.contact-form__row');

        companyInput.change(function() {
            if (this.value === "Compensa") {
                officeInputWrapper.fadeIn();
            } else {
                officeInputWrapper.fadeOut();
                officeInput.value = '';
            }
        });
    }

}
export default questionnaire;